import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BASE_SPACING_X } from 'HubStyleTokens/sizes';
import { isIE11 } from '../utils/BrowserTest';
const Toolbar = styled.div.withConfig({
  displayName: "AbstractToolbar__Toolbar",
  componentId: "qo8a49-0"
})(["padding:", " 0 0 ", ";"], BASE_SPACING_X, BASE_SPACING_X);
const ToolbarInner = styled.div.withConfig({
  displayName: "AbstractToolbar__ToolbarInner",
  componentId: "qo8a49-1"
})(["align-items:center;display:flex;flex-wrap:", ";justify-content:", ";margin:-", " 0 0 -", ";> * + *{margin-left:", ";}"], props => props.responsive && 'wrap', ({
  $justifyEnd
}) => $justifyEnd ? 'flex-end' : 'space-between', BASE_SPACING_X, BASE_SPACING_X, BASE_SPACING_X);
const SlotFlexContainer = styled.div.withConfig({
  displayName: "AbstractToolbar__SlotFlexContainer",
  componentId: "qo8a49-2"
})(["align-items:center;display:flex;flex-shrink:0;flex:", ";> * + *{margin-left:", ";}> .private-button.private-button{flex-shrink:0;margin-top:0;width:auto;}"], props => props.__distributeEvenly && !isIE11() && '1 1 0%', BASE_SPACING_X);
const StartSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__StartSlot",
  componentId: "qo8a49-3"
})(["justify-content:flex-start;"]);
const MiddleSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__MiddleSlot",
  componentId: "qo8a49-4"
})(["flex-grow:0;flex-shrink:1;justify-content:center;white-space:", ";"], props => props.__distributeEvenly && 'nowrap');
const EndSlot = styled(SlotFlexContainer).withConfig({
  displayName: "AbstractToolbar__EndSlot",
  componentId: "qo8a49-5"
})(["justify-content:flex-end;"]);

const AbstractToolbar = props => {
  const {
    __distributeEvenly,
    Inner,
    End,
    endSlot,
    Middle,
    middleSlot,
    responsive,
    role,
    Start,
    startSlot
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["__distributeEvenly", "Inner", "End", "endSlot", "Middle", "middleSlot", "responsive", "role", "Start", "startSlot"]);

  return /*#__PURE__*/_jsx(Toolbar, Object.assign({}, rest, {
    role: role,
    children: /*#__PURE__*/_jsxs(Inner, {
      responsive: responsive,
      $justifyEnd: !!endSlot && !startSlot && !middleSlot,
      children: [startSlot ? /*#__PURE__*/_jsx(Start, {
        __distributeEvenly: __distributeEvenly,
        children: startSlot
      }) : null, middleSlot ? /*#__PURE__*/_jsx(Middle, {
        __distributeEvenly: __distributeEvenly,
        children: middleSlot
      }) : null, endSlot ? /*#__PURE__*/_jsx(End, {
        __distributeEvenly: __distributeEvenly,
        children: endSlot
      }) : null]
    })
  }));
};

AbstractToolbar.propTypes = {
  __distributeEvenly: PropTypes.bool,
  End: PropTypes.elementType,
  endSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  Inner: PropTypes.elementType,
  Middle: PropTypes.elementType,
  middleSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  responsive: PropTypes.bool.isRequired,
  role: PropTypes.string,
  Start: PropTypes.elementType,
  startSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  flush: PropTypes.bool
};
AbstractToolbar.defaultProps = {
  End: EndSlot,
  Inner: ToolbarInner,
  Middle: MiddleSlot,
  responsive: true,
  role: 'group',
  Start: StartSlot
};
AbstractToolbar.displayName = 'AbstractToolbar';
export default AbstractToolbar;